import React from "react";
import ReactDOM from "react-dom/client";
import { Navigate, Route, Routes, HashRouter } from "react-router-dom";
import App from "./components/app";
import { dashboardroutes } from "./routing/dashboard";
import Login from "./components/login/login";
import Network from "./components/network";
import Policy from "./components/policy";

const Root = () => {
  return (
    <HashRouter>
      <Network />
      
      <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" exact={true} element={<Login />} />
      <Route path="/privacypolicy" exact={true} element={<Policy />} />


        <Route element={<App />}>
          {dashboardroutes.map((route) => (
            <Route
              key={route.id}
              exact={route.exact}
              path={route.path}
              element={route.element}
            />
          ))}
        </Route>
      </Routes>
    </HashRouter>

   
  );
};
// The PWA/service-worker support was removed. This unregisters any service
// worker left over from an older build (and clears its caches) so returning
// users are never served a stale bundle. Safe to delete once every client has
// loaded the app at least once after this change.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
  if (window.caches && caches.keys) {
    caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);
